import { z } from "zod";

export const orgSchema = z.object({
  id: z.number(),
  name: z.string(),
  profile_name: z.string(),
  org_type: z.string(), // TODO: Enum
  profile_type: z.string().nullable(), // TODO: Enum
  profile_subtype: z.string().nullable().optional(),
  shipping_cost_per: z.number(),
  landed_cost_per: z.number(),
  status: z.string(), // TODO: Enum
  cancellation_reason: z.string().nullable(),
  trial_period: z.number(),
  base_shelves_limit: z.number(),
  icp_status: z.string().nullable(),
  contact_number: z.string().nullable(),
  free_trial_start_date: z.string().date().nullable(),
  days_active: z.number(),
  marketplaces: z.string().array(),
  account_manager: z.number(),
  is_visible: z.boolean(),
  mcp_token: z.string().nullable(),
});

export type Organization = z.infer<typeof orgSchema>;
